import qs from 'qs';

export const generateQuery = (params) => qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true });
export const generateUrl = (url, options) => {
  const { hash, ...params } = options || {};
  const query = generateQuery(params);
  return `${url}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
};

/**
 * @param {URLSearchParams} urlParams
 * @param {string[]} paramsToRemove
 */
export const removeUrlParams = (urlParams, paramsToRemove = []) => {
  for (const param of paramsToRemove) {
    urlParams.delete(param);
  }
  return urlParams;
};
